// Libraries
import React from 'react';
import PropTypes from 'prop-types';

// Enums
import QuestionFormat from 'engagement/enums/QuestionFormat';
import { EngagementReportQuestionType } from 'engagementReport/enums/propTypes';

// Components
import SummaryNotes from 'engagementReport/components/base/SummaryNotes';
import SingleSelectReport from 'engagementReport/components/singleSelect/SingleSelectReport';
import OrderedReport from 'engagementReport/components/ordered/OrderedReport';
import MatrixReport from 'engagementReport/components/matrix/MatrixReport';
import GeolocationReport from 'engagementReport/components/geolocation/GeolocationReport';
import ImageReport from 'engagementReport/components/image/ImageReport';
import BasicReport from 'engagementReport/components/basic/BasicReport';
import OpenBudgetReport from 'engagementReport/components/openBudget/OpenBudgetReport';

const renderReport = (question, defaultLanguage) => {
  switch (question.format) {
    case QuestionFormat.SINGLE_SELECT:
    case QuestionFormat.MULTI_SELECT:
    case QuestionFormat.BUDGET:
    case QuestionFormat.DROPDOWN:
    case QuestionFormat.NUMERIC:
    case QuestionFormat.SLIDER:
    case QuestionFormat.RATING:
      return <SingleSelectReport question={question} />;
    case QuestionFormat.ORDERED:
      return <OrderedReport question={question} />;
    case QuestionFormat.MATRIX:
      return <MatrixReport question={question} />;
    case QuestionFormat.GEOLOCATION:
      return <GeolocationReport question={question} />;
    case QuestionFormat.IMAGE:
      return <ImageReport question={question} />;
    case QuestionFormat.BASIC:
      return <BasicReport question={question} />;
    case QuestionFormat.BUDGET_OPEN:
      return <OpenBudgetReport question={question} defaultLanguage={defaultLanguage} />;
    default:
      return null;
  }
};

const EngagementReportQuestion = ({ question, defaultLanguage }) => {
  const { title, summaryNotes } = question;

  return (
    <div className="engagement-report-question">
      <h2 className="title is-5 is-primary-color">{title}</h2>
      {renderReport(question, defaultLanguage)}
      {summaryNotes && <SummaryNotes summaryNotes={summaryNotes} />}
    </div>
  );
};

EngagementReportQuestion.propTypes = {
  question: EngagementReportQuestionType.isRequired,
  defaultLanguage: PropTypes.string.isRequired,
};

export default EngagementReportQuestion;
